import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/complete-machine-delivery/check-success.png'


const _withScopeId = n => (_pushScopeId("data-v-0c1dc35a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delivery-service-detail-2-0-wrap" }
const _hoisted_2 = { class: "material-wrap" }
const _hoisted_3 = { class: "material-content van-hairline--top" }
const _hoisted_4 = { class: "material-name-wrap" }
const _hoisted_5 = { class: "material-name" }
const _hoisted_6 = { class: "material-code" }
const _hoisted_7 = { class: "material-num" }
const _hoisted_8 = { class: "img-wrap" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "img-wrap" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "img-wrap" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "list-item-wrap" }
const _hoisted_15 = { class: "list-item-name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-success" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "16",
    height: "16",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 检查通过 ")
], -1))
const _hoisted_17 = { class: "video-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-tip-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "16",
    height: "16",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 已领取 ")
], -1))
const _hoisted_19 = {
  key: 0,
  class: "auth-list"
}
const _hoisted_20 = {
  key: 0,
  class: "auth-item"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-name" }, "三者险：", -1))
const _hoisted_22 = { class: "auth-desc" }
const _hoisted_23 = {
  key: 1,
  class: "auth-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-name" }, "意外险：", -1))
const _hoisted_25 = { class: "auth-desc" }
const _hoisted_26 = { class: "video-wrap" }
const _hoisted_27 = {
  key: 0,
  class: "operator xag-page__footer"
}

import ShrinkWrap from '@/components/shrink-wrap.vue'
import BlockWrap from './block-wrap.vue'
import {
  ref,
  onMounted,
  computed,
  watch,
  nextTick,
  withDefaults,
} from 'vue'
import { Button, ImagePreview, Toast, Dialog } from 'vant'
import UploadFile from '@/components/upload/newUploadFIle.vue'
import type { InitData } from '@/components/upload/newUploadFIle.vue'
import EvaluatePopup from './evaluate-popup.vue'
import {
  getDeliveryServiceDetail,
  getPreDeliveryServiceDetail,
  getAuthInfo,
  getUnfinishedDeliveryDetail,
  confirmOrder,
  getTicketVideo,
} from '@/apis/complete-machine-delivery'
import type { TicketItemDetail } from '@/types/complete-machine-delivery'
import CommonImagePreview from '@/components/CommonImagePreview.vue'
import { showToastLoading, clearToast } from '@/utils/tools'
import { commonErrorHandle } from '@/utils/error-handle'
import { statusInfoMap } from '@/defination/complete-machine-delivery'

interface MaterialItem {
  name: string
  code: string
  num: number
}

interface VideoItem {
  isVideo: boolean
  url: string
}

interface FormData {
  materialList: MaterialItem[]
  checkOutboundProductInfoImg: string[]
  unpackingInspectionImg: string[]
  productAssemblyImg: string[]
  productAssemblyList: string[]
  policyExplanation: VideoItem[]
  operationalSafety: VideoItem[]
  threePartyInsurance: string
  insurance: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'delivery-service-detail-2_0',
  props: {
    detail: null
  },
  emits: ['init'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { detail?: TicketItemDetail };





expose({
  initDataHandle,
})

// 评价颜色
const titleColor = computed(() => {
  return statusInfoMap.get(props.detail?.info?.status)?.color || '#000000'
})

let evaluatePopupEdit = ref(false)

let formData = ref<FormData>({
  materialList: [],
  checkOutboundProductInfoImg: [],
  unpackingInspectionImg: [],
  productAssemblyImg: [],
  productAssemblyList: ['固件升级', '地面调试', '基础功能测试', '飞行测试'],
  policyExplanation: [],
  operationalSafety: [],
  threePartyInsurance: '',
  insurance: '',
})

let policyExplanationUploadNewRef = ref<InstanceType<typeof UploadFile>>()
let operationalSafetyUploadNewRef = ref<InstanceType<typeof UploadFile>>()

let policyExplanationUploadFn: InitData
let operationalSafetyUploadFn: InitData

function initPolicyExplanationUpload(data: InitData) {
  policyExplanationUploadFn = data
}

function initOperationalSafetyUpload(data: InitData) {
  operationalSafetyUploadFn = data
}

watch(
  () => props.detail,
  () => {
    initDataHandle()
  },
  {
    immediate: true,
  }
)

onMounted(() => {
  // policyExplanationUploadRef.value?.setFileList(formData.value.policyExplanation)
  // operationalSafetyUploadRef.value?.setFileList(formData.value.operationalSafety)
})

let isShowUnfinishedDelivery = computed(() => {
  return props.detail?.info?.status === 30
})

let isShowFinish = computed(() => {
  return props.detail?.info?.status === 30
})

let isShowEvaluation = computed(() => {
  return (
    [40].includes(props.detail?.info?.status) &&
    !props.detail?.assess_info?.score &&
    props.detail?.info.is_assess_auth
  )
})

let isShowViewEvaluation = computed(() => {
  return [40].includes(props.detail?.info?.status) && !!props.detail?.assess_info?.score
})

let isShowOperator = computed(() => {
  return isShowFinish.value || isShowEvaluation.value || isShowViewEvaluation.value
})

async function initDataHandle() {
  console.log('initDataHandle')
  if (props.detail) {
    // 设置物料
    showToastLoading()
    console.log('ddsdsd', props.detail)
    formData.value.materialList = (props.detail.material_list || []).map((_) => {
      return {
        name: _.good_name,
        code: _.code,
        num: _.cnt,
      }
    })
    //
    if ([30, 40].includes(props.detail.info.status)) {
      await Promise.all([
        getDeliveryServiceDetailHandle(),
        getPreDeliveryServiceDetailHandle(),
        getAuthInfoHandle(),
        getTicketVideoHandle(),
      ])
    }
    clearToast()
  }
}

function showImg(index: number, img: Array<string>) {
  ImagePreview({
    images: img,
    startPosition: index,
  })
}

let evaluatePopupVisible = ref(false)

let evaluatePopupRef = ref<InstanceType<typeof EvaluatePopup>>()

async function confirmHandler(type: string) {
  if (type === 'evaluation') {
    evaluatePopupVisible.value = true
    evaluatePopupEdit.value = true
  } else if (type === 'unfinish') {
    try {
      await Dialog.confirm({
        message: '是否确认未交付',
        confirmButtonColor: '#03BA78',
      })
      showToastLoading()
      let data = await getUnfinishedDeliveryDetail({ order_no: props.detail!.info.order_no })
      console.log('getUnfinishedDeliveryDetail', data)
      emits('init')
    } catch (e) {
      console.log('getUnfinishedDeliveryDetail', e)
    }
    clearToast()
  } else if (type === 'finish') {
    await Dialog.confirm({
      message: '是否确认交付',
      confirmButtonColor: '#03BA78',
    })
    try {
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      await confirmOrder({ order_no: props.detail.info.order_no as string })
      Toast.success('确认服务完成！')
      emits('init')
    } catch (e) {
      commonErrorHandle(e)
      console.log('getUnfinishedDeliveryDetail', e)
    }
  } else if (type === 'viewEvaluation') {
    evaluatePopupVisible.value = true
    evaluatePopupEdit.value = false
    evaluatePopupRef.value?.initData()
  }
}

// 获取现场交付详情
async function getDeliveryServiceDetailHandle() {
  try {
    await getDeliveryServiceDetail({ wo_guid: props.detail.info.guid })
  } catch (e) {
    console.log('getDeliveryServiceDetailHandle', e)
  }
}

// 获取预交付详情
async function getPreDeliveryServiceDetailHandle() {
  try {
    let data = await getPreDeliveryServiceDetail({ wo_guid: props.detail.info.guid })
    console.log('getPreDeliveryServiceDetailHandle', data)
    formData.value.productAssemblyImg = data.check_outbound_product || []
    formData.value.unpackingInspectionImg = data.open_box_check || []
  } catch (e) {
    console.log('getPreDeliveryServiceDetailHandle', e)
  }
}

async function getAuthInfoHandle() {
  try {
    let data = await getAuthInfo({ wo_guid: props.detail.info.guid })
    console.log('getAuthInfoHandle')
    formData.value.threePartyInsurance = data.policy_no || '-'
    formData.value.insurance = data.policy_number || '-'
  } catch (e) {
    console.log('getPreDeliveryServiceDetailHandle', e)
  }
}

// 获取工单视频
async function getTicketVideoHandle() {
  try {
    let data = await getTicketVideo({ wo_guid: props.detail.info.guid })
    console.log('getTicketVideoHandle', data)
    formData.value.policyExplanation = [
      {
        isVideo: true,
        url: data.video_url || '',
      },
    ]
    formData.value.operationalSafety = [
      {
        isVideo: true,
        url: data.safety_video_url || '',
      },
    ]
    nextTick(() => {
      // policyExplanationUploadNewRef.value?.setFileList(formData.value.policyExplanation)
      // operationalSafetyUploadNewRef.value?.setFileList(formData.value.operationalSafety)
      policyExplanationUploadFn.setFileList(
        formData.value.policyExplanation.map((item) => ({
          isVideo: item.isVideo,
          url: item.url,
        }))
      )
      operationalSafetyUploadFn.setFileList(
        formData.value.operationalSafety.map((item) => ({
          isVideo: item.isVideo,
          url: item.url,
        }))
      )
    })
  } catch (e) {
    console.log('getTicketVideoHandle', e)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "status-tag",
        style: _normalizeStyle({ color: _unref(titleColor) })
      }, [
        _createElementVNode("div", null, _toDisplayString(__props.detail.info.status_text), 1)
      ], 4),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ShrinkWrap, { title: "物料清单" }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).materialList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["material-item", {
                'van-hairline--bottom':
                  (index === 0 && _unref(formData).materialList.length !== 1) ||
                  index !== _unref(formData).materialList.length - 1,
              }]),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.code), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(`x${item.num}`), 1)
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(BlockWrap, { title: "核对出库和产品信息" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            (_unref(formData).unpackingInspectionImg.length)
              ? (_openBlock(), _createBlock(CommonImagePreview, {
                  key: 0,
                  guids: _unref(formData).unpackingInspectionImg,
                  width: 76,
                  height: 76
                }, null, 8, ["guids"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "暂无数据"))
          ])
        ]),
        _: 1
      }),
      _createVNode(BlockWrap, { title: "开箱检" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            (_unref(formData).unpackingInspectionImg.length)
              ? (_openBlock(), _createBlock(CommonImagePreview, {
                  key: 0,
                  guids: _unref(formData).unpackingInspectionImg,
                  width: 76,
                  height: 76
                }, null, 8, ["guids"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, "暂无数据"))
          ])
        ]),
        _: 1
      }),
      _createVNode(BlockWrap, { title: "产品组装" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            (_unref(formData).productAssemblyImg.length)
              ? (_openBlock(), _createBlock(CommonImagePreview, {
                  key: 0,
                  guids: _unref(formData).productAssemblyImg,
                  width: 76,
                  height: 76
                }, null, 8, ["guids"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无数据"))
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).productAssemblyList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item van-hairline--top",
                key: index
              }, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(item), 1),
                _hoisted_16
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(BlockWrap, { title: "政策说明讲解" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(UploadFile, {
              ref_key: "policyExplanationUploadNewRef",
              ref: policyExplanationUploadNewRef,
              showUpload: false,
              deletable: false,
              className: "policyExplanationUploadRef",
              onInit: initPolicyExplanationUpload
            }, null, 512)
          ])
        ]),
        _: 1
      }),
      _createVNode(BlockWrap, {
        title: "领取设备权益",
        class: "auth-wrap"
      }, {
        right: _withCtx(() => [
          _hoisted_18
        ]),
        default: _withCtx(() => [
          (_unref(formData).threePartyInsurance || _unref(formData).insurance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_unref(formData).threePartyInsurance)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(formData).threePartyInsurance || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(formData).insurance)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(formData).insurance || '-'), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(BlockWrap, { title: "操作安全规范宣讲" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(UploadFile, {
              key: "111",
              ref_key: "operationalSafetyUploadNewRef",
              ref: operationalSafetyUploadNewRef,
              showUpload: false,
              deletable: false,
              className: "operationalSafetyUploadRef",
              onInit: initOperationalSafetyUpload
            }, null, 512)
          ])
        ]),
        _: 1
      })
    ]),
    (_unref(isShowOperator))
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          (_unref(isShowUnfinishedDelivery))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                class: "un-finish-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmHandler('unfinish')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("未完成交付")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowFinish))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                class: "confirm-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmHandler('finish')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认接收设备")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowEvaluation))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 2,
                class: "confirm-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (confirmHandler('evaluation')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("评价")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isShowViewEvaluation))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 3,
                class: "confirm-button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmHandler('viewEvaluation')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看评价")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(EvaluatePopup, {
      ref_key: "evaluatePopupRef",
      ref: evaluatePopupRef,
      show: _unref(evaluatePopupVisible),
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_isRef(evaluatePopupVisible) ? (evaluatePopupVisible).value = $event : evaluatePopupVisible = $event)),
      onSuccess: _cache[5] || (_cache[5] = ($event: any) => (emits('init'))),
      order_no: props?.detail?.info.order_no,
      isEdit: _unref(evaluatePopupEdit),
      assess_info: props?.detail?.assess_info
    }, null, 8, ["show", "order_no", "isEdit", "assess_info"])
  ], 64))
}
}

})